const { Configuration, OpenAIApi } = require('openai');
const apiKey = "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";
const configuration = new Configuration({ apiKey });
const openai = new OpenAIApi(configuration);

export async function sendMsgToOpenAI(message) {
    const response = await openai.createCompletion({
        model: 'text-davinci-003',
        prompt: message,
        temperature: 0.7,
        max_tokens: 256,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0
    });
    return response.data.choices[0].text;
}
